import emailVerificationErrorTranslation from './index.json';

export default emailVerificationErrorTranslation;
